module.exports = __webpack_public_path__ + "img/ximgLogo@2x.bc5808e1.png";